/**
 * PipeSeparated Component
 *
 * Displays two values separated by a pipe (|) with proper centering.
 * The pipe character is anchored in the center, with left/right values
 * aligned around it.
 *
 * Usage:
 *   <PipeSeparated
 *     left={<span className="positive">5</span>}
 *     right={<span className="negative">3</span>}
 *   />
 *
 *   <PipeSeparated
 *     left="wins"
 *     right="losses"
 *     fontSize="0.75rem"
 *   />
 */

export default function PipeSeparated({
  left,
  right,
  fontSize = "1.5rem",
  pipeColor = "#6b7280",
  pipeFontSize = null,
  gap = "0.5rem",
  minWidth = "3rem",
  style = {},
  className = ""
}) {
  return (
    <div
      className={className}
      style={{
        fontSize,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style
      }}
    >
      <span style={{ textAlign: "right", minWidth }}>
        {left}
      </span>
      <span style={{
        color: pipeColor,
        margin: `0 ${gap}`,
        fontSize: pipeFontSize || fontSize
      }}>
        |
      </span>
      <span style={{ textAlign: "left", minWidth }}>
        {right}
      </span>
    </div>
  );
}
